import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.css";

import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import store from "./redux/store";
import { Provider } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
 <Router>
  <React.StrictMode>
   <Provider store={store}>
    <ToastContainer
     theme="dark"
     position="top-right"
     autoClose={3000}
     closeOnClick
     pauseOnHover={false}
    />
    <App />
   </Provider>
  </React.StrictMode>
 </Router>
);
